export default "__VITE_ASSET___B$uhMyt__"